module.exports = __webpack_public_path__ + "static/blairWitch-756317d91937927b723be66193984325.jpg";